import React, { FC } from 'react';

import { Control } from 'react-hook-form';

import AcSelect from 'components/AcSelect/AcSelect';
import { FormControl, FormField, FormItem } from 'components/ui';

import Input from '../../../../components/Input/Input';
import InputSelectDropdown from '../../../../components/InputSelectDropdown/InputSelectDropdown';
import RichText from '../../../../components/RichText/RichText';
import { EPopupTriggersAction, PopupsFormFields } from '../constants';
import { CustomChip } from '../CustomChip';

type TriggersSectionProps = {
  control: Control<PopupsFormFields>;
  offersIds: any;
};

const TriggersSection: FC<TriggersSectionProps> = ({ control, offersIds }) => {
  const renderIdValue: React.FC<any> = (selected: any) => {
    const selectedLength = selected?.length;
    if (selectedLength === 0) return 'Select';
    if (selectedLength < offersIds?.length && selectedLength > 1)
      return `${selected[0]} and ${selectedLength - 1} more...`;
    if (selectedLength === 1) return selected[0];
    return 'All';
  };

  return (
    <div>
      <RichText
        title="Triggers"
        description="Define when the offer will be presented to the player"
        className="mb-5"
      />
      <FormField
        control={control}
        name="triggersAction"
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormControl>
              <InputSelectDropdown
                disabled
                key={value}
                label="Action"
                defaultSelected={{
                  value: EPopupTriggersAction.PURCHASE_COMPLETED,
                  label: 'Purchase completed'
                }}
                options={[
                  {
                    value: EPopupTriggersAction.PURCHASE_COMPLETED,
                    label: 'Purchase completed'
                  }
                ]}
                onOptionChange={onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <CustomChip />
      <FormField
        control={control}
        name="triggersFrequency"
        render={({ field: { value, onChange, onBlur } }) => (
          <FormItem>
            <FormControl>
              <Input
                min={1}
                label="Frequency"
                type="number"
                data-testid="triggers-frequency-input"
                value={value}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    onChange('');
                  } else {
                    onChange(e.target.valueAsNumber);
                  }
                }}
                onBlur={(e) => {
                  if (e.target.value === '') {
                    onChange(1);
                  }
                  onBlur();
                }}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <CustomChip />
      <FormField
        control={control}
        name="triggersOfferExternalIds"
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormControl>
              <AcSelect
                header="Offer ID"
                items={offersIds}
                isCheckBox
                setSelectedItems={onChange}
                value={value || []}
                isSelectAllEnabled={true}
                isApplyBtnEnabled
                renderValue={renderIdValue}
                dataTestValidationId="popupExternalIdsValidationTxt"
                dataTestListId="dashPopupExternalIdsList"
                dataTestBoxId="popupExternalIdsBox"
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};

export default TriggersSection;
